
import { Component, Prop, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { patchUser } from '@/utils/user'

@Component({})
export default class VbitStatusBanner extends Mixins<MixinInterface>() {
    @Prop({ required: true }) module!: string

    loading = false
    vbitTranslation = null

    get vbitStatusStrings() {
        return this.$store.getters.effectiveTexts['vbit_status']
    }

    get hasVbitStatus() {
        return !!this.vbitStatus
    }

    get vbitStatus() {
        if (!this.vbitStatusStrings) return null

        const strId = Object.keys(this.vbitStatusStrings).find((str) => {
            if (str.includes(this.module)) {
                return this.isValidStatus(str.split('.')[1])
            }
            return false
        })

        if (strId && strId != this.$store.getters.frontEndSettings?.vbitStatus?.[this.module]) {
            this.vbitTranslation = this.vbitStatusStrings[strId]
            return strId
        }
        return null
    }

    isValidStatus(argTimestamp: string) {
        const year = parseInt(argTimestamp.slice(0, 4), 10)
        const month = parseInt(argTimestamp.slice(4, 6), 10) - 1
        const day = parseInt(argTimestamp.slice(6, 8), 10)

        const argDate = new Date(year, month, day)

        const today = new Date()
        return argDate < today
    }

    async dismissBanner() {
        if (!this.vbitStatus) return

        try {
            this.loading = true
            const feCopy = this.lodash.cloneDeep(this.$store.getters.frontEndSettings)
            feCopy.vbitStatus = feCopy.vbitStatus ?? {}

            feCopy.vbitStatus[this.module] = this.vbitStatus

            this.$store.commit('frontEndSettings', feCopy)

            if (this.currentUser) {
                let params = {
                    id: this.currentUser.id,
                    type: this.currentUser.type,
                    frontEndSettings: JSON.stringify(this.$store.getters?.frontEndSettings),
                }

                await patchUser(this.currentUser.id, params)
            }
            this.vbitTranslation = null
        } finally {
            this.loading = false
        }
    }
}
